export const obtenerTotalProductos = (productos=[]) =>{

    let total = 0
    for (let i = 0; i< productos.length;i++){
        total += productos[i].cantidad * productos[i].valor
    }



    return total

}